<template>
  <section class="container">
    <div class="row">
      <div class="col text-center">
        <img src="/assets/images/not.jpg" alt="401" />
        <p>Ops... Não Autorizado.</p>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped></style>